import { fetchCampaign } from '@/api/campaignPlaner';
import { useCampaignOptimizationUrl } from '@/dashboards/CampaignOptimization/hooks/useCampaignOptimizationUrl';
import {
    keepPreviousData,
    queryOptions,
    useQuery,
} from '@tanstack/react-query';

export const useGetCampaignDetails = () => {
    const {
        params: { projectId, campaignId },
    } = useCampaignOptimizationUrl();

    return useQuery(
        queryOptions({
            queryKey: ['savedCampaign', projectId, campaignId],
            queryFn: () => fetchCampaign(projectId, campaignId),
            staleTime: Infinity,
            placeholderData: keepPreviousData,
        }),
    );
};
